import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';

/**
 * 프로모션 코드 인증 모달 상태 관리.
 * 상품별로 인증된 코드를 Map<productId, codeName>으로 추적하며,
 * 구매 시 인증된 코드를 주문 payload에 포함시킨다.
 * toastClassName: Physical/Digital별 CTA 높이가 달라 토스트 위치(marginBottom)가 다름.
 */
export const useVerificationCode = (toastClassName: string) => {
  const [verificationModalOpen, setVerificationModalOpen] = useState(false);
  const [selectedProductIdForCode, setSelectedProductIdForCode] = useState<
    number | null
  >(null);
  // key: productId, value: 검증된 promotionCode
  const [verifiedProductCodes, setVerifiedProductCodes] = useState<
    Map<number, string>
  >(new Map());

  const openVerificationModal = useCallback((productId: number) => {
    setSelectedProductIdForCode(productId);
    setVerificationModalOpen(true);
  }, []);

  const closeVerificationModal = useCallback(() => {
    setVerificationModalOpen(false);
    setSelectedProductIdForCode(null);
  }, []);

  const handleVerified = useCallback(
    (codeName: string) => {
      toast.success('코드 검증이 완료되었습니다.', {
        className: toastClassName,
      });
      if (selectedProductIdForCode) {
        setVerifiedProductCodes(prev =>
          new Map(prev).set(selectedProductIdForCode, codeName)
        );
      }
      setVerificationModalOpen(false);
      setSelectedProductIdForCode(null);
    },
    [selectedProductIdForCode, toastClassName]
  );

  return {
    verificationModalOpen,
    selectedProductIdForCode,
    verifiedProductCodes,
    openVerificationModal,
    closeVerificationModal,
    handleVerified,
  };
};
